import { render, staticRenderFns } from "./Tracking.vue?vue&type=template&id=04bc3705&scoped=true&"
import script from "./Tracking.vue?vue&type=script&lang=js&"
export * from "./Tracking.vue?vue&type=script&lang=js&"
import style0 from "./Tracking.vue?vue&type=style&index=0&id=04bc3705&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bc3705",
  null
  
)

export default component.exports